export default __webpack_public_path__ + "static/media/v2-story-1.d0014da8.jpg";